import React, { Component } from "react";
import "./style.scss";
import Modal from "assets/images/modal-avatar.png";
import filter from "assets/images/filter.png";
import {
  Appointments,
  PurchaseHistory,
  PersonalDetails,
  Favourites,
} from "./Details";
import { history } from "helpers";
import classnames from "classnames";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import {
  NormalButton,
  NormalModal,
  InputSearch,
  NormalInput,
  NormalCheckbox,
  SearchInputKeyboard,
} from "component/common";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getCustomer } from "redux/actions/customer";
import closeIcon from "assets/images/close.png";
import { Details } from "./Detail";
import { Account } from "./Account";
import { TreatmentHistory } from "./TreatmentHistory";
import { withTranslation } from "react-i18next";
import _ from "lodash";
import { getCommonApi } from "redux/actions/common";
import QRCode from "react-qr-code";
import { IoSearchCircle } from "react-icons/io5";

export class AccountDetailsClass extends Component {
  constructor(props) {
    super(props);
    this.childAccountInput = React.createRef();
  }
  state = {
    activeTab: "1",
    isOpenTreatmentDone: false,
    formFields: {
      auto: false,
      totalOutstanding: "",
      outstanding: "",
    },
    isActiveTab: "detail",
    customerOption: [],
    visible: false,
  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };
  componentDidMount() {
    this.getCustomer();
  }

  getCustomer = () => {
    this.props.getCustomer(this.props.match.params.id).then((res) => {
      console.log(res, "asdasdfasdfasdf resssssss");
    });
  };

  handleDialog = () => {
    let { isOpenTreatmentDone } = this.state;
    isOpenTreatmentDone = false;
    this.setState({
      isOpenTreatmentDone,
    });
  };

  handleTopup = () => {
    let { isOpenTreatmentDone } = this.state;
    isOpenTreatmentDone = true;
    this.setState({
      isOpenTreatmentDone,
    });
  };

  handleChange = ({ target: { value, name } }) => {
    let formFields = Object.assign({}, this.state.formFields);
    console.log(value, name, "ghfhgfhjfkhjg");
    formFields[name] = value;

    this.setState({
      formFields,
    });
  };

  handleSearch = async (value) => {
    // event.persist();
    let { formFields, visible } = this.state;
    formFields.custName = value;
    await this.setState({ formFields });
    if (!this.debouncedFn) {
      this.debouncedFn = _.debounce(async () => {
        this.search();
      }, 500);
    }
    this.debouncedFn();
  };

  search = (searchString) => {
    let { formFields } = this.state;
    this.props
      .getCommonApi(`custappt/?search=${formFields.custName}`)
      .then((key) => {
        let { status, data } = key;
        if (status === 200) {
          // for (let value of data) {
          //     customerList.push({ value: value.id, label: value.emp_name })
          // }
          this.setState({ customerOption: data });
        }
      });
  };
  handleClick = async () => {
    let { formFields } = this.state;
    await this.setState({ visible: true });
    let data = formFields["custName"] ?? "";
    await this.search();
    // if (!this.state.visible) {
    //   document.addEventListener("click", this.handleOutsideClick, false);
    // } else {
    //   document.removeEventListener("click", this.handleOutsideClick, false);
    // }

    // if (this.state.visible) {
    //   let { basicApptDetail } = this.props;
    //   this.search(basicApptDetail);
    // }
    // this.setState((prevState) => ({
    //   visible: !prevState.visible,
    // }));
  };

  handleOutsideClick = (e) => {
    if (this.node != null) {
      if (this.node.contains(e.target)) {
        return;
      }
    }
    this.handleClick();
  };
  handleSelectCustomer = async (data) => {
    await this.setState({
      customerOption: [],
    });
    this.props.history.push(`/admin/customerplus/${data.id}/details`);
    window.location.reload();
    this.handleClick();
  };

  render() {
    let { customerDetail = {}, t } = this.props;
    console.log(customerDetail, "asdasdfasdfasdf === sdfasdfagf");
    let { id, cust_name, cust_code, cust_refer, cust_img, is_allowedit } =
      customerDetail;
    let {
      isOpenTreatmentDone,
      formFields,
      isActiveTab,
      visible,
      customerOption,
    } = this.state;
    return (
      <div className="view-detail p-3 mt-3">
        <div className="row pb-md-4 rowGapBottom">
          <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-6 head-label-nav">
            <p
              className="category"
              onClick={() => history.push("/admin/customerplus")}
            >
              {t(`Customer`)}
            </p>
            <i className="icon-right mx-3"></i>
            <p className="sub-category"> {t(`Customer Details`)}</p>
          </div>
          {/* d-flex justify-content-lg-start justify-content-xl-end  align-items-center */}
          <div className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-6">
            <div className="row align-items-center rowGapBottom">
              <div className="col-12 col-sm-7 col-md-7 col-lg-7 col-xl-7 ">
                {this.props.tokenDetails.ipadkey ? (
                  <SearchInputKeyboard
                    onRef={(ref) => (this.childAccountInput = ref)}
                    onChangeTextInput={(e) => this.handleSearch(e)}
                    handleIconSearch={() => {
                      this.handleClick();
                    }}
                    handleHideModal={(val) => this.setState({ visible: val })}
                    focusValue={"customerName"}
                    placeHolderText={"Search Customer.."}
                    keyboardModalValue
                    positionAlignmentLeft=" treatmentKeyboardLeft"
                    parentPassIntialValue={formFields.custName}
                  />
                ) : (
                  <NormalInput
                    placeholder="Search Customer.."
                    value={formFields.custName}
                    name="custName"
                    onChange={(e) => this.handleSearch(e.target.value)}
                    // onKeyDown={this.handlecheckIN}
                    iconsVisible
                    onClickIcon={() => {
                      this.handleClick();
                    }}
                  />
                )}
              </div>

              <div className="w-100 col-12 col-sm-5 col-md-5 col-lg-5 col-xl-5">
                <NormalButton
                  mainbg={true}
                  className="col-12 fs-15 float-right"
                  label="Add Customer"
                  onClick={() =>
                    this.props.history.push("/admin/customerplus/add")
                  }
                />
              </div>
              {/* <div className="bg-white ">
                <img src={filter} alt="" />
              </div> */}
            </div>
          </div>
        </div>
        <div className="view-detail-box p-3 mt-3">
          <div className="row pb-3">
            <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3  d-flex align-items-center text-center">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                  <img
                    className="modal-avatar"
                    src={cust_img ? cust_img : Modal}
                    alt=""
                    height="80"
                    width="80"
                  />
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                  <p className="fs-28 fw-500 customer-detail-heading py-2">
                    {t(cust_name)}
                  </p>
                  <p className="fs-18 fw-500 customer-detail-heading py-2">
                    {t(cust_refer)}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-7 col-md-7 col-lg-7 col-xl-7 row  icon-change menu-list rowGapColumnGap">
              <button
                className={`btn outline-btn col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1 fs-14 float-left text-capitalize detail`}
                onClick={() =>
                  history.push(
                    `/admin/customerplus/${this.props.match.params.id}/details`
                  )
                }
              >
                {t("Detail")}
              </button>
              <button
                className={`btn outline-btn col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1 fs-14 active float-left text-capitalize account`}
                onClick={() =>
                  history.push(
                    `/admin/customerplus/${this.props.match.params.id}/account`
                  )
                }
              >
                {t("Account")}
              </button>
              <button
                className={`btn outline-btn col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1 fs-14 float-left text-capitalize hold`}
                onClick={() =>
                  history.push(
                    `/admin/customerplus/${this.props.match.params.id}/hold`
                  )
                }
              >
                {t("Hold")}
              </button>
              <button
                className={`btn outline-btn col-12 col-sm-5 col-md-5 col-lg-5 col-xl-3  fs-14 float-left text-capitalize invoice`}
                onClick={() =>
                  history.push(
                    `/admin/customerplus/${this.props.match.params.id}/invoice`
                  )
                }
              >
                {t("Invoice History")}
              </button>
              <button
                className={`btn outline-btn col-12 col-sm-5 col-md-5 col-lg-5 col-xl-3  fs-14 float-left text-capitalize productpurchases`}
                onClick={() =>
                  history.push(
                    `/admin/customerplus/${this.props.match.params.id}/productpurchases`
                  )
                }
              >
                {t("Product Purchase")}
              </button>
              <button
                className={`btn outline-btn col-12 col-sm-5 col-md-5 col-lg-5 col-xl-2  fs-14  float-left text-capitalize document`}
                onClick={() =>
                  history.push(
                    `/admin/customerplus/${this.props.match.params.id}/documents`
                  )
                }
              >
                {t("Documents")}
              </button>
              <button
                className={`btn outline-btn col-12 col-sm-5 col-md-5 col-lg-5 col-xl-2  fs-14  float-left text-capitalize vouchers`}
                onClick={() =>
                  history.push(
                    `/admin/customerplus/${this.props.match.params.id}/vouchers`
                  )
                }
              >
                {t("Vouchers")}
              </button>
              <button
                className={`btn outline-btn col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1 fs-14  float-left text-capitalize vouchers`}
                onClick={() =>
                  history.push(
                    `/admin/customerplus/${this.props.match.params.id}/point`
                  )
                }
              >
                {t("Point")}
              </button>
                <button
                  className={`btn outline-btn col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1 fs-14  float-left text-capitalize vouchers`}
                  onClick={() =>
                    history.push(
                      `/admin/customerplus/${this.props.match.params.id}/membergetmembers`
                    )
                  }
                >
                  {t("MGM")}
                </button>

              {/* <button className={`btn outline-btn col-2 mx-2 fs-14 float-left text-capitalize treatment`} onClick={() => history.push(`/admin/customerplus/${this.props.match.params.id}/treatment`)}>
                                Treatment History
                            </button> */}
            </div>
            <div className="col-12 col-sm-1 col-md-1 col-lg-2 col-xl-1 mt-2 icon-change edit d-flex justify-content-center align-items-center mobileFlexDirection">
              {is_allowedit ? (
                <button
                  className="btn outline-btn col-2 mx-2 fs-15 float-right text-capitalize"
                  onClick={() =>
                    this.props.history.push(
                      `/admin/customerplus/${this.props.match.params.id}/editCustomer`
                    )
                  }
                >
                  <span className="icon-edit mr-2"></span>
                  {t(`Edit`)}
                </button>
              ) : null}
              {this.props.tokenDetails?.customerqrdisplay && (
                <div className="qrCodeParent">
                  <QRCode value={cust_code} size={100} />
                </div>
              )}
            </div>
          </div>
          <Account id={this.props.match.params.id}></Account>
        </div>
        {visible ? (
          <div className="customerSearch-block">
            <div className="d-flex mt-4 table table-header w-100 m-0">
              <div className="col-2">{t("Name")}</div>
              <div className="col-2">{t("Phone")}</div>
              <div className="col-2">{t("Cust Code")}</div>
              <div className="col-2">{t("Reference")}</div>
              <div className="col-3">{t("Email")}</div>
              <div className="col-1 d-none">{t("NRIC")}</div>
            </div>
            <div className="response-table w-100">
              {customerOption.length > 0 ? (
                customerOption.map((item, index) => {
                  return (
                    <div
                      className="row m-0 table-body w-100 border"
                      onClick={() => this.handleSelectCustomer(item)}
                      key={index}
                    >
                      <div className="col-2">{item.cust_name}</div>
                      <div className="col-2">{item.cust_phone2}</div>
                      <div className="col-2">{item.cust_code}</div>
                      <div className="col-2">{item.cust_refer}</div>
                      <div className="col-3">{item.cust_email}</div>
                      <div className="col-1 d-none">{item.cust_nric}</div>
                    </div>
                  );
                })
              ) : (
                <div className="text-center w-100">
                  {t("No Data are available")}
                </div>
              )}
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  customerDetail: state.customer.customerDetail,
  tokenDetails: state.authStore.tokenDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCustomer,
      getCommonApi,
    },
    dispatch
  );
};

export const AccountDetails = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(AccountDetailsClass)
);
